import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { DocumentTextIcon, DocumentArrowDownIcon } from '@heroicons/react/24/solid';

const QuickFormNavigation = ({
    formType,
    setFormType,
    onBack
}) => {
    const { t } = useTranslation();

    return (
        <div className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 shadow-sm">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                <div className="flex flex-col gap-6">
                    <div className="flex flex-col sm:flex-row justify-between items-center gap-6">
                        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
                            <button
                                onClick={() => setFormType('extrajudicial')}
                                className={`px-6 py-3 rounded-xl flex items-center justify-center gap-3 transition-all duration-200 transform hover:scale-102 shadow-sm hover:shadow-md ${formType === 'extrajudicial'
                                        ? 'bg-primary-600 text-white hover:bg-primary-700'
                                        : 'bg-gray-50 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-600'
                                    } min-w-[200px]`}
                            >
                                <DocumentArrowDownIcon className="w-5 h-5" />
                                <span className="font-medium">{t("Gastos Extrajudiciales")}</span>
                            </button>
                            <button
                                onClick={() => setFormType('demanda')}
                                className={`px-6 py-3 rounded-xl flex items-center justify-center gap-3 transition-all duration-200 transform hover:scale-102 shadow-sm hover:shadow-md ${formType === 'demanda'
                                        ? 'bg-primary-600 text-white hover:bg-primary-700'
                                        : 'bg-gray-50 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-600'
                                    } min-w-[200px]`}
                            >
                                <DocumentTextIcon className="w-5 h-5" />
                                <span className="font-medium">{t("Demanda Gastos")}</span>
                            </button>
                            <button
                                onClick={() => setFormType('reiteracion')}
                                className={`px-6 py-3 rounded-xl flex items-center justify-center gap-3 transition-all duration-200 transform hover:scale-102 shadow-sm hover:shadow-md ${formType === 'reiteracion'
                                        ? 'bg-primary-600 text-white hover:bg-primary-700'
                                        : 'bg-gray-50 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-600'
                                    } min-w-[200px]`}
                            >
                                <DocumentTextIcon className="w-5 h-5" />
                                <span className="font-medium">{t("Reiteración Gastos")}</span>
                            </button>
                        </div>
                        <div className="flex items-center gap-2 w-full sm:w-auto">
                            <button
                                onClick={onBack}
                                className="w-full sm:w-auto px-6 py-3 text-sm rounded-xl bg-gray-50 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-600 flex items-center justify-center gap-3 transition-all duration-200 transform hover:scale-102 shadow-sm hover:shadow-md font-medium"
                            >
                                {t("Volver atrás")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

QuickFormNavigation.propTypes = {
    formType: PropTypes.string.isRequired,
    setFormType: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired
};

export default QuickFormNavigation; 